<template>
  <div class="container">
    <hr class="hr-footer">

    <div class=" footer-dark">
      <footer class="footer">
        <div class="footer-row">
          <div class="footer-col contact">
            <h3 class="footer-title">
              بهترین خودت باش
            </h3>

            <ul class="footer-list">
              <li>
                <NuxtLink to="https://wa.me/989021616483">
                  تماس با ما
                </NuxtLink>
              </li>

              <li>
                <NuxtLink to="/about-us">
                  درباره ما
                </NuxtLink>
              </li>

              <li>
                <NuxtLink to="/terms">
                  قوانین و مقررات
                </NuxtLink>
              </li>

              <li>
                <NuxtLink to="/faq">
                  سوالات متداول
                </NuxtLink>
              </li>
            </ul>
          </div>

          <div class="footer-col about">
            <h3 class="footer-title">
              حقوق کپی رایت
            </h3>

            <p class="footer-text"> {{ copyright }} </p>
          </div>

          <div class="footer-col social">
            <div>
              <nuxt-link class="footer-icon" to="https://instagram.com/fiatre.ir">
                <JJIcon icon="instagram" />
              </nuxt-link>

              <nuxt-link class="footer-icon" to="https://wa.me/989021616483">
                <JJIcon icon="whatsapp" />
              </nuxt-link>

              <nuxt-link class="footer-icon" to="https://t.me/fiatre">
                <JJIcon icon="telegram" />
              </nuxt-link>
            </div>

            <div>
              <nuxt-link to="https://mag.fiatre.ir/">
                <img v-lazy-load 
                  class="fiatre-mag mt-4"
                  data-src="/assets/images/fiatremag-smal.png"
                  alt="fiatreMag"
                >
              </nuxt-link>
            </div>
          </div>
          <!-- <div class="footer-col social">
          </div> -->
        </div>

        <div class="certification-logos">
          <img v-lazy-load  data-src="/assets/images/samandehi.png" alt="Samandehi" class="cert-logo">

          <nuxt-link
            href="https://trustseal.enamad.ir/?id=165550&Code=17pT7etE2rxSIRb0m5Z0"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img v-lazy-load  data-src="/assets/images/enamad.png" alt="Enamad" class="cert-logo">
          </nuxt-link>

          <img v-lazy-load  data-src="/assets/images/satra.png" alt="Satra" class="cert-logo">

          <img v-lazy-load  data-src="/assets/images/sapra.png" alt="Sapra" class="cert-logo">
        </div>

        <div class="footer-bottom">
          <!-- <p class="footer-copyright primary-bold"> {{ copyright }} </p> -->
        </div>
      </footer>
    </div>
  </div>
</template>

<script setup lang="ts">
import JJIcon from '~/components/core/icons/JJIcon.vue';

const {data: settings, pending} = await useApiFetch('settings/');

const terms = computed(() => {
  const termsItem = settings.value?.results?.find((item) => item?.key === 'terms_text');
  return termsItem?.value || '';
});

const isLoading = computed(() => pending.value);

const copyright = computed(() => {
  const copyrightItem = settings.value?.results?.find((item) => item?.key === 'copyright');
  return copyrightItem?.value || '';
});

</script>

<style lang="scss">
.footer-dark {
  padding: 50px 0;
  color: $black;
}

.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
}



.footer-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
}

.footer-col {
  flex: 1;
  margin: 20px;
  text-align: center;

  @media (min-width: 769px) {
    text-align:center;
  }
}

.footer-title {
  margin-top: 0;
  margin-bottom: 12px;
  font-weight: bold;
  font-size: 16px;
}

.footer-list {
  padding-right: 2rem;
  list-style: none;
  line-height: 1.6;
  font-size: 14px;
  margin-bottom: 0;
  display: flex;
  gap: 16px;

  @media (max-width: 1400px) {
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 768px) {
    flex-direction: row;
  }

  @media (max-width: 450px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}

.footer-list a {
  color: $black;
  text-decoration: none;
}

.footer-list a:hover {
  opacity: 0.6;
}

.footer-text {
  font-size: 14px;
}

.footer-icon {
  font-size: 20px;
  width: 36px;
  height: 36px;
  line-height: 36px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 1px solid $black;
  border-radius: 50%;
  margin: 0 8px;
  color: $black;
  opacity: 0.75;

  &:hover {
    opacity: 0.9;
  }
}

.footer-copyright {
  text-align: center;
  padding-top: 24px;
  opacity: 0.3;
  font-size: 13px;
  margin-bottom: 0;
}

.primary-bold {
  font-weight: 700;
  font-size: 20px;
  color: $white;
}

.certification-logos {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
  flex-wrap: wrap;

  .cert-logo {
    width: 70px;
    aspect-ratio: 1;
    object-fit: contain;
  }
}
.fiatre-mag {
  width: 140px;
  height: 70px;

}

.hr-footer {

  background-color: red;
}
</style>
